import React from 'react';
// This is the one place we can import it
// eslint-disable-next-line no-restricted-imports
import { getTheme, HighContrastSelector, PrimaryButton } from '@fluentui/react';
import { WhiteStatic } from 'theme';

export const SalusPrimaryButton = props => {
  const { palette } = getTheme();
  return (
    <PrimaryButton
      {...props}
      title={props.text}
      styles={{
        ...props.styles,
        rootFocused: {
          ...props?.styles?.rootFocused,
          outlineColor: `${palette.black} !important`,
          selectors: {
            [HighContrastSelector]: {
              outlineColor: 'inherit !important'
            }
          }
        },
        icon: {
          ...props?.styles?.icon,
          color: WhiteStatic,
          selectors: {
            [HighContrastSelector]: {
              color: 'inherit !important'
            }
          }
        },
        label: {
          ...props?.styles?.label,
          color: WhiteStatic,
          selectors: {
            [HighContrastSelector]: {
              color: 'inherit !important'
            }
          }
        },
        labelDisabled: {
          ...props?.styles?.labelDisabled,
          color: palette.neutralTertiary,
          selectors: {
            [HighContrastSelector]: {
              color: 'inherit !important'
            }
          }
        }
      }}
    >
      {props.children}
    </PrimaryButton>
  );
};
